import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { loadCachedRealProfiles, syncRealProfilesFromServer } from '../data/realProfiles';
import type { ActivityEntry, OperatorProfile, RealProfile } from '../types/profiles';

export function useRealProfiles() {
  const { user, getIdToken } = useAuth();
  const initial = loadCachedRealProfiles();
  const [profiles, setProfiles] = useState<RealProfile[]>(initial.profiles);
  const [operators, setOperators] = useState<OperatorProfile[]>(initial.operators);
  const [activity, setActivity] = useState<ActivityEntry[]>(initial.activity);
  const [loading, setLoading] = useState(Boolean(user));

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    const cached = loadCachedRealProfiles();
    setProfiles(cached.profiles);
    setOperators(cached.operators);
    setActivity(cached.activity);
    getIdToken()
      .then((token) => {
        if (!token) throw new Error('Sem token de autenticação para sincronizar perfis');
        return syncRealProfilesFromServer(token);
      })
      .then((data) => {
        setProfiles(data.profiles);
        setOperators(data.operators);
        setActivity(data.activity);
      })
      .catch((err) => console.error('Falha ao sincronizar perfis reais via servidor', err))
      .finally(() => setLoading(false));
  }, [user, getIdToken]);

  return { profiles, operators, activity, loading };
}
